/**
 * Gate of the extended Duration / Work display contract: three decimals,
 * unit abbreviations in cells, one accepted unit per input.
 *
 * Off by default. A build turns it on with REACT_APP_DISPLAY_UNITS_EXTENDED;
 * a single browser can turn it on for itself (local storage key
 * `displayUnitsExtended`) to check a tenant before the build flips.
 */
const STORAGE_KEY = "displayUnitsExtended";

export const isDisplayUnitsExtended = () => {
	if (process.env.REACT_APP_DISPLAY_UNITS_EXTENDED === "true") return true;
	try {
		return window.localStorage.getItem(STORAGE_KEY) === "true";
	} catch (e) {
		return false;
	}
};
